export default __webpack_public_path__ + "static/media/add_more_here_bubble.2f03c09f.svg";